import { type ESystemLanguage } from '@flecto/types'

import { useLanguage } from '../useLanguage'
import { i18n } from './utils'

export const useLocaleName = (locale: string) => {
  const language = useLanguage()
  const translate = i18n.get(language)

  return translate?.get(locale as ESystemLanguage) ?? ''
}
